<template>
  <VueResizable class="user-help-tree" :active="['r']" width="220px" height="100%" v-loading="loading">
    <div class="title-1">
      <toolTip class="title" title="帮助中心" style="width: 100%;">
        帮助中心
      </toolTip>
    </div>
    <Element :listData="dataset" :isReviews="isReviews" :select="select"></Element>
  </VueResizable>
</template>
<script>
import Element from './element'
import api from '@/services/api/help/help'
import VueResizable from 'vue-resizable'
export default {
  props: ['isReviews', 'list', 'select'],
  components: {
    Element,
    VueResizable
  },
  data() {
    return {
      dataset: [],
      loading: false
    }
  },
  created() {
    this.init()
  },
  destroyed() {
  },
  methods: {
    async init() {
      if(this.isReviews) {
        this.dataset = this.list
        return
      }
      this.loading = true
      let result =  await api.documentIndex({per_page: 999, page: 1, level: 2, pid: 0})
      this.dataset = result.data
      let id = Number(this.$route.query.id || 0)
      if(!id && result.data.length > 0 && result.data[0] && result.data[0].children && result.data[0].children.length > 0) {
        id = result.data[0].children[0].document_draft_id
        const newUrl = this.$route.path + `?id=${id}`
        window.history.replaceState('', '', `${window.location.pathname}#${newUrl}`)
        this.$router.replace({query: { id }})
      }
      this.loading = false
    },
  }
}
</script>
<style lang="scss">
.user-help-tree {
  border-right: 1px solid rgba(32,32,32,0.08);
  box-sizing: border-box;
  height: 100% !important;
  overflow-x: hidden;
  overflow-y: overlay;
  padding: 0 16px;
  flex-shrink: 0;
  .title-1 {
    padding: 28px 0 0 16px;
    font-size: 18px;
    font-weight: 500;
  }
}
</style>
